import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "components";
import "./style.scss";

interface TagsModalProps {
    tags: any | undefined;
    show: boolean;
    handleCloseModal: () => void;
    onConfirmClick: (val: number[]) => void;
}

const TagsModal: React.FC<TagsModalProps> = ({
    tags,
    show,
    handleCloseModal,
    onConfirmClick,
}) => {
    const [SOP, setSOP] = useState<number[]>([]);
    return (
        <Modal
            show={show}
            onHide={() => {
                handleCloseModal && handleCloseModal();
            }}
            className="rtl modalContainer"
            centered
        >
            <Modal.Header closeButton>
                <h5>ویژگی سفارشات دریافتی</h5>
            </Modal.Header>
            <Modal.Body className="modalBody">
                <div className="tagsContainer">
                    {tags &&
                        tags?.data?.map((tag: any) => (
                            <div
                                className={`${SOP.some((el) => el === tag.id) ? "selected" : ""} tags scrollbar`}
                                onClick={() => {
                                    setSOP((prv) => {
                                        if (prv.some((el) => el === tag.id)) {
                                            return prv.filter(
                                                (el) => el !== tag.id
                                            );
                                        }
                                        let temp = [...prv];
                                        temp.push(tag.id);
                                        return temp;
                                    });
                                }}
                            >
                                {tag.title}
                            </div>
                        ))}
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center w-100">
                <Button
                    btnText="ثبت دریافتی"
                    className="solid is-green big full-width"
                    handleClick={() => onConfirmClick(SOP)}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default TagsModal;
